import React from 'react'
import Grid from '@material-ui/core/Grid'
import TickInside from '../assets/tick_inside.png'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import green from '@material-ui/core/colors/green'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import IconButton from '@material-ui/core/IconButton'
import LinkIcon from '@material-ui/icons/Link'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import MailIcon from '@material-ui/icons/Mail'
import Tooltip from '@material-ui/core/Tooltip'
import Snackbar from '@material-ui/core/Snackbar'

import { isMobileOrTablet } from '../helpers/device.js'
import { getWhatsappLink, getEmailLink } from '../helpers/share.js'
import TextField from '@material-ui/core/TextField'
import { InputAdornment } from '@material-ui/core'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import { formatMoneyInput, parseToFloat } from '../helpers/payment.js'
import PaymentLink from '../modules/paymentLink.js'
import StringHelper from '../helpers/string-helper.js'

class Success extends React.Component {
  
  state = {
    open: false,
    vertical: 'top',
    horizontal: 'center',
    balance: ''
  }

  componentDidMount() {
    const {
      bookingInfo: { cc_payment_amount: initialBalance }
    } = this.props

    const debit = parseToFloat(initialBalance);
    const hasDebit = Number.isFinite(debit);

    this.setState({
      hasDebit: hasDebit,
      balanceLimit: hasDebit ? debit : 0,
      balance: hasDebit ? debit : 0,
    })
  }


  handleBalanceChange = (event) => {

    const { balanceLimit } = this.state
    
    let value = event.target.value.replace(',', '.')

    value = formatMoneyInput(value)

    // permite apagar o campo
    if (value === '') {
      this.setState({ balance: '' })
      return
    }

    let numericValue = parseFloat(value)

    if (!isNaN(numericValue) && numericValue > balanceLimit) {
      this.setState({ balance: balanceLimit.toFixed(2) })
      return
    }

    this.setState({ balance: value })
  }

   handleBalancePayClick = async () => {

     const baseUrl = sessionStorage.getItem('url'),
          property = sessionStorage.getItem('propertyId'),
          booking = sessionStorage.getItem('bookingId');

      const { balance: amountToPay } = this.state;
      
      const paymentLinkResponse = await PaymentLink.getPaymentLink(baseUrl,property,booking,amountToPay);

      let paymentLinkURL = null;
      if (paymentLinkResponse.status) {
          paymentLinkURL = paymentLinkResponse.result.payment_link
      }

      if(StringHelper.isNotEmpty(paymentLinkURL)){
        
        const newWindow = window.open('', '_blank');

        try {
          newWindow.location.href = paymentLinkURL;
        } catch (err) {
          newWindow.close();
        }
      }

  }

  handleClick = (state) => () => {
    const textField = document.createElement('textarea')
    const {
      bookingInfo: { edp: url }
    } = this.props
    textField.innerText = url
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()

    this.setState({ open: true, ...state })
  }

  handleClickShareWhatsapp = (translate) => {
    const {
      bookingInfo: { edp: url },
      propertyName
    } = this.props
    const isMobile = isMobileOrTablet()
    const title = propertyName + ' - ' + translate('shareCheckinOnlineMsg')

    window.location.href = getWhatsappLink(url, title, isMobile)
  }

  handleClickShareEmail = (translate) => {
    const {
      bookingInfo: { edp: url },
      propertyName
    } = this.props
    const subject = propertyName + ' - Check in Online'
    const fullBody = translate('shareCheckinOnlineMsg') + ' ' + url

    window.location.href = getEmailLink(subject, fullBody)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  gotoHome = () => {
    const {
      bookingInfo: { edp: url },
      additionalGuests
    } = this.props
    if (additionalGuests) {
      window.location.href = url
    } else {
      window.location.reload()
    }
  }

  render() {
    const { classes, translate, additionalGuests, propertyInfo: { checkin_online_payment: checkin_online_payment_active } } = this.props
    const { hasDebit, vertical, horizontal, open } = this.state
    const buttonLabel = additionalGuests
      ? translate('forwardToNextGuestLabel')
      : translate('nextLabel')

    return (
      <React.Fragment>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              marginTop: 10,
              textAlign: 'center'
            }}
          >
            <img src={TickInside} alt="tick" height="100" width="100" />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center', marginLeft:5, marginRight:5 }}>
            <Typography component="h4" variant="h4">
              {translate('successTitle')}
            </Typography>
            <Typography component="h4" variant="h4">
              {translate('successSubTitle')}
            </Typography>
          </Grid>

          <Grid item xs={12} style={{ textAlign: 'center', marginTop: 20, marginLeft:5, marginRight:5 }}>
            <Typography component="h6" variant="h6">
              {translate('successText')}
            </Typography>
          </Grid>


          {hasDebit && checkin_online_payment_active === '1' && (
            <>
              <Grid item xs={12} style={{ textAlign: 'center', marginTop: 30, marginLeft:5, marginRight:5 }}>
                <Typography variant="subtitle2">
                  {translate('balanceToPayMessage')}
                </Typography>
              </Grid>

              <Grid item xs={12} style={{ textAlign: 'center', marginTop: 20 }}>
                
                <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                  {translate('balanceToPayLabel')}
                </Typography>

                <Grid container alignItems="end" justifyContent="center" spacing={2}>
                  <Grid item>
                    <TextField
                      id="cc_payment_amount"
                      name="cc_payment_amount"
                      value={this.state.balance}
                      error={false}
                      helperText={''}
                      style={{ width: 180 }}
                      onChange={this.handleBalanceChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MonetizationOnIcon />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>

                  <Grid item>
                    <Button variant="contained" onClick={this.handleBalancePayClick}>
                      {translate('payLabel')}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          

          <Grid item xs={12} style={{ textAlign: 'center', marginTop: 40, marginLeft:5, marginRight:5 }}>
            <Typography variant="subtitle2">
              {translate('checkinOtherGuestsMessage')}
            </Typography>

            <Button
              variant="contained"
              color="primary"
              className={classNames(classes.margin, classes.cssRoot)}
              onClick={this.gotoHome}
            >
              {buttonLabel}
            </Button>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Tooltip title={translate('shareLinkLabel')}>
              <IconButton
                color="primary"
                className={classes.button}
                component="span"
                size="medium"
                onClick={this.handleClick({
                  vertical: 'bottom',
                  horizontal: 'center'
                })}
              >
                <LinkIcon className={classes.largeIcon} />
              </IconButton>
            </Tooltip>

            <Tooltip title={translate('shareLinkWhatsappLabel')}>
              <IconButton
                color="primary"
                className={classes.button}
                component="span"
                size="medium"
                onClick={() => {
                  this.handleClickShareWhatsapp(translate)
                }}
              >
                <WhatsAppIcon className={classes.largeIcon} />
              </IconButton>
            </Tooltip>

            <Tooltip title={translate('shareLinkEmailLabel')}>
              <IconButton
                color="primary"
                className={classes.button}
                component="span"
                size="medium"
                onClick={() => {
                  this.handleClickShareEmail(translate)
                }}
              >
                <MailIcon className={classes.largeIcon} />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
          message={<span id="message-id">{translate('linkSharedLabel')}</span>}
        />
      </React.Fragment>
    )
  }
}

Success.propTypes = {
  classes: PropTypes.object.isRequired
}

const styles = (theme) => ({
  margin: {
    margin: theme.spacing(4),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cssRoot: {
    color: '#fff',
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    }
  },
  largeIcon: {
    width: 35,
    height: 35
  }
})

export default compose(withStyles(styles), connect())(withTranslate(Success))
